import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_LoginURL, API_BannerURL } from "../../../src/config";

export default function Navbar() {
    const [profileData, setProfileData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        // const source = axios.CancelToken.source();

        const fetchProfileData = async () => {
            try {
                const response = await axios.get(
                    `${API_LoginURL}User/LoggedInProfileData`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: localStorage.getItem("token"),
                        },
                        // cancelToken: source.token
                    }
                );

                localStorage.setItem(
                    "teacherInfo",
                    JSON.stringify(response.data[0])
                );

                // Assuming the APICancelToken.source(); returns an array with profile data in the first element
                const userData = response.data[0] || {};
                setProfileData({
                    username: userData.userName,
                    profilePicture: userData.profilePicture,
                });
            } catch (err) {
                if (!axios.isCancel(err)) {
                    setError(err.message);
                    console.error("Error fetching profile data:", err);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchProfileData();

        // return () => {
        //   source.cancel('Component unmounted, request canceled');
        // };
    }, []);

    // Profile picture URL handler
    const getProfilePicture = () => {
        if (loading) return "assets/images/loading-spinner.gif";
        if (error || !profileData?.profilePicture) {
            return "assets/images/faces/face28.png";
        }

        // Handle both full URLs and relative paths
        return profileData.profilePicture.startsWith("http")
            ? profileData.profilePicture
            : `${API_BannerURL}${profileData.profilePicture.replace(
                  /^\/?/,
                  ""
              )}`;
    };

    const logout = () => {
        localStorage.clear();
        window.location.href = "/";
    };

    return (
        <nav className="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
            <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <a className="navbar-brand brand-logo me-5" href="/">
                    <img
                        src="/assets/images/logo.png"
                        className="me-2"
                        alt="logo"
                    />
                    XR4STEM
                </a>
                <a className="navbar-brand brand-logo-mini" href="/">
                    <img src="/assets/images/logo.png" alt="logo" />
                </a>
            </div>

            <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
                <ul className="navbar-nav navbar-nav-right">
                    <li className="nav-item nav-profile dropdown">
                        <a
                            className="nav-link dropdown-toggle"
                            href="#"
                            data-bs-toggle="dropdown"
                            id="profileDropdown"
                        >
                            {profileData?.username && (
                                <span className="ms-2 p-2 d-none d-lg-inline">
                                    {profileData.username}
                                </span>
                            )}
                            <img
                                src={getProfilePicture()}
                                alt="Profile"
                                onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                        "assets/images/faces/face28.png";
                                }}
                            />
                        </a>
                        <div
                            className="dropdown-menu dropdown-menu-right navbar-dropdown"
                            aria-labelledby="profileDropdown"
                        >
                            {/* <a className="dropdown-item">
                <i className="ti-settings text-primary"></i> Settings
              </a> */}
                            <a className="dropdown-item" onClick={logout}>
                                <i className="ti-power-off text-primary"></i>{" "}
                                Log out
                            </a>
                        </div>
                    </li>
                    {/* <li className="nav-item nav-settings d-none d-lg-flex">
            <a className="btn btn-warning" href="#">
              Forum
            </a>
          </li> */}
                </ul>
            </div>
        </nav>
    );
}
